<template>
  <div id="app">

    <b-container fluid>
      <b-row class="justify-content-md-center">
        <b-col cols="12">
          <div class="header">
            <v-header></v-header>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="main">
            <router-view v-if="isRouterAlive" :key="key" />
          </div>
        </b-col>
        <b-col cols="12">
          <div class="footer">
            <v-footer></v-footer>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {

    "v-header": Header,
    "v-footer": Footer,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
 
  computed: {
    // 解决切换路由后,之前的组件不销毁问题,再次进入同一组件不会给提示,所有页面开发完后,再去除
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
  methods: {
    
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style>
@import "./assets/css/global.css";

@import "./assets/css/footer.css";
</style>
<style>
#app {
  margin: 0;
  padding: 0;
}

.main {
  /* min-height: 800px; */
  background: #fff;
  margin: 0 auto;
}
</style>
